module.exports = __webpack_public_path__ + "static/1-fa0a321b3fbf2a0e753e53b752b42fc4.jpg";